/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import {
  PidxInlineFormMessagesModule,
  PidxLoaderModule,
  PidxSkeletonLoaderModule,
  PidxTimerLabelModule,
} from '@myprofile-ui/pidx-ui-components'
import { PidxUtilsModule } from '@myprofile-ui/pidx-utils'
import { TranslatePipe } from '@ngx-translate/core'
import { MyProfileEmailEditorComponent } from './components/myprofile-email-editor/myprofile-email-editor.component'
import { MyProfileEmailListComponent } from './components/myprofile-email-list/myprofile-email-list.component'
import { MyProfileEmailVerificationComponent } from './components/myprofile-email-verification/myprofile-email-verification.component'
import { MyProfileEmailWidgetComponent } from './myprofile-email-widget.component'
import { RESTRICT_GLOBAL_UI_CHANGES } from '../../../pidx-utils/src/lib/helpers/restrictGlobalUIChanges.injectionToken'
import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular'

@NgModule({
  imports: [
    CommonModule,
    PidxLoaderModule,
    PidxSkeletonLoaderModule,
    ReactiveFormsModule,
    TranslatePipe,
    PidxInlineFormMessagesModule,
    PidxTimerLabelModule,
    PidxUtilsModule,
    PorscheDesignSystemModule,
    MyProfileEmailVerificationComponent,
  ],
  declarations: [MyProfileEmailWidgetComponent, MyProfileEmailListComponent, MyProfileEmailEditorComponent],
  exports: [MyProfileEmailWidgetComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MyProfileEmailWidgetModule {
  static forRoot(restrictGlobalUIChanges: boolean): ModuleWithProviders<MyProfileEmailWidgetModule> {
    return {
      ngModule: MyProfileEmailWidgetModule,
      providers: [{ provide: RESTRICT_GLOBAL_UI_CHANGES, useValue: restrictGlobalUIChanges }],
    }
  }
}
